import { useCallback } from 'react';
import { IllustrativeIcon, Txt } from '@vst/beam';
import { UpArrow } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { CustomDecorativeModal } from '@app/components/Modal';
import { useScreenResolution } from '@app/hooks';

import { ErrorEnum } from '../utils/types';

import styles from './styles.module.scss';

type CheckoutSuccessProps = {
  dataAmount: number;
  isModalOpen: boolean;
  handleClose: (isSuccess: boolean, error?: ErrorEnum) => void;
};

const CheckoutSuccess = (props: CheckoutSuccessProps): JSX.Element => {
  const { dataAmount, handleClose, isModalOpen } = props;

  const { t } = useTranslation('BuyMore');

  const { isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  const handleClick = useCallback(() => {
    handleClose(true);
  }, [handleClose]);

  return (
    <CustomDecorativeModal
      header={t('Checkout.success.title', { dataAmount })}
      isOpen={isModalOpen}
      actions={{
        primary: {
          label: t('Checkout.success.buttons.done'),
          onClick: handleClick,
        },
      }}
      onClose={handleClick}
      icon={<IllustrativeIcon icon={UpArrow} color="teal_600" />}
      surfaceProps={{ className: styles['customSuccessHeader'] }}
    >
      <Txt color="subtle" variant={isMobile ? 'bodySmallRegular' : 'bodyLargeRegular'}>
        {t('Checkout.success.description')}
      </Txt>
    </CustomDecorativeModal>
  );
};

export default CheckoutSuccess;
